import { jsx as _jsx } from "react/jsx-runtime";
export default function FieldInput({ id = "input", value = "", disabled = false, onBlur, onChange }) {
    const handleChange = (event)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const handleBlur = (event)=>{
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    return /*#__PURE__*/ _jsx("input", {
        id: id,
        type: "text",
        value: value,
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: disabled,
        style: styles.input
    });
}
const styles = {
    input: {
        width: "100%",
        height: "100%",
        border: "none",
        backgroundColor: "#e1f5fe"
    }
};
